import './table-hac.scss';
import React, {useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import {useTranslation} from 'react-i18next';
import {Alert, Snackbar} from '@mui/material';
import SortableHeaderCell from '../../common/table/sortable-header-cell';
import TableHacFilters from './components/table-hac-filters';
import TableHacRow from './components/table-hac-row';
import { SORT_FIELDS } from './domain/table-hac.constants';
import { getRowKey } from './domain/table-hac.utils';
import usePmaHacTable from './hooks/use-pma-hac-table';

function TableHac({reload, onDataLoaded, showSummary = true, onSummaryChange = () => {}}) {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const {
    countries,
    dataLoaded,
    filters,
    filteredHacs,
    hacs,
    order,
    orderBy,
    retailers,
    rows,
    snackbarMessage,
    snackbarOpen,
    handleApplyFilter,
    handleFilterChange,
    handleRequestSort,
    handleSnackbarClose,
    resetFilters,
  } = usePmaHacTable({ reload, onDataLoaded, t });

  useEffect(() => {
    onSummaryChange({ total: filteredHacs.length });
  }, [filteredHacs.length, onSummaryChange]);

  return (
    <>
      {dataLoaded ? (
        hacs && hacs.length !== 0 ? (
          <div>
            <TableHacFilters
              t={t}
              filters={filters}
              countries={countries}
              retailers={retailers}
              // showPmaFilter={isPmaManager} // TODO(PMAGM-pma-filter): enable once backend is ready
              // pmas={pmas} // TODO(PMAGM-pma-filter): enable once backend is ready
              resultCount={filteredHacs.length}
              showSummary={showSummary}
              onFilterChange={handleFilterChange}
              onApply={handleApplyFilter}
              onReset={resetFilters}
            />

            {filteredHacs.length !== 0 ? (
              <div className="table-wrapper">
                <Table sx={{minWidth: 650}} aria-label="simple table" className="user-table pma-hac">
                  <TableHead>
                    <TableRow>
                      <SortableHeaderCell
                        field={SORT_FIELDS.NAME}
                        orderBy={orderBy}
                        order={order}
                        onRequestSort={handleRequestSort}
                        label={t('common-name')}
                      />

                      <SortableHeaderCell
                        field={SORT_FIELDS.LAST_NAME}
                        orderBy={orderBy}
                        order={order}
                        onRequestSort={handleRequestSort}
                        label={t('common-last-name')}
                      />

                      <TableCell align="left">
                        <span className="text">{t('common-phone')}</span>
                      </TableCell>

                      <SortableHeaderCell
                        field={SORT_FIELDS.RETAILER}
                        orderBy={orderBy}
                        order={order}
                        onRequestSort={handleRequestSort}
                        label={t('common-retailer')}
                      />

                      <TableCell align="left">
                        <span className="text">{t('common-country')}</span>
                      </TableCell>

                      <SortableHeaderCell
                        field={SORT_FIELDS.PMA_TYPE}
                        orderBy={orderBy}
                        order={order}
                        onRequestSort={handleRequestSort}
                        label={t('common-assigned-as')}
                      />

                      <TableCell align="center">
                        <span className="text">{t('common-survey')}</span>
                      </TableCell>

                      <SortableHeaderCell
                        field={SORT_FIELDS.LAST_UPDATE}
                        orderBy={orderBy}
                        order={order}
                        onRequestSort={handleRequestSort}
                        label={t('common-last-update')}
                      />

                      <TableCell align="left"></TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {rows.map((row, index) => (
                      <TableHacRow
                        key={`${getRowKey(row)}-${index}`}
                        row={row}
                        t={t}
                        navigate={navigate}
                      />
                    ))}
                  </TableBody>
                </Table>
              </div>
            ) : (
              <div className="no-result">
                <h2 className="txt-center">
                  &nbsp;<small>{t('admin-main-tab3-text-empty')}</small>
                </h2>
              </div>
            )}
          </div>
        ) : (
          <div className="no-result">
            <h2 className="txt-center">{t('pma-hac-tab-title-empty')}</h2>
          </div>
        )
      ) : (
        <div>{t('common-loading')}</div>
      )}

      <Snackbar open={snackbarOpen} autoHideDuration={3000} onClose={handleSnackbarClose}>
        <Alert severity="error" sx={{width: '100%'}}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </>
  );
}

export default TableHac;
